import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useEffect, useState } from "react";
import { openFormApi, submitFormApi } from "../../../Api";

const FormContainer = styled(Box)(({ theme }) => ({
  margin: "0 auto",
  height: "auto",
  boxSizing: "border-box",
  padding: theme.spacing(2),
  boxShadow: "0px 0px 20px rgba(0,0,0,0.1)",
  backgroundColor: "#fff",
  borderRadius: "0px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: theme.spacing(2),
}));

const InputContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));

const FieldWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));

const Label = styled(Typography)(({ theme }) => ({
  font: 'normal normal 800 14px "Nunito Sans", "Open Sans", sans-serif',
  color: "#5a6066",
  variant: "body1",
  component: "span",

  [theme.breakpoints.between("xs", "md")]: {
    font: 'normal normal 800 12px "Nunito Sans", "Open Sans", sans-serif',
  },

  [theme.breakpoints.between("md", "lg")]: {
    font: 'normal normal 800 14px "Nunito Sans", "Open Sans", sans-serif',
  },

  [theme.breakpoints.up("lg")]: {
    font: 'normal normal 800 16px "Nunito Sans", "Open Sans", sans-serif',
  },
}));

const OutlinedInputComponent = styled(OutlinedInput)(({ theme }) => ({
  lineHeight: "16px",
  margin: 0,
  fontSize: "16px",
  color: "#7c7d7c",
  borderColor: "#bbbbbb",
  borderRadius: 0,
  border: "1px solid rgba(0, 0, 0, 0.1)",
  width: "100%",
  fontFamily: '"Nunito Sans", "Open Sans", sans-serif',
  backgroundColor: "#fff",
  height: "40px",
  ".css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input": {
    padding: "7px 16px",
  },
}));

const SelectComponent = styled(Select)(({ theme }) => ({
  padding: `0px`,
  margin: 0,
  fontSize: "16px",
  borderColor: "#bbbbbb",
  border: "1px solid rgba(0, 0, 0, 0.1)",
  width: "100%",
  fontFamily: '"Nunito Sans", "Open Sans", sans-serif',
  backgroundColor: "#fff",
  ".css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select":
  {
    minHeight: "0px",
  },
}));

const CountryCode = styled(Typography)(({ theme }) => ({
  font: "normal normal 400 14px Open Sans",
  textAlign: "center",
  color: "#5a6066",
  vaiant: "h6",
  component: "p",
}));
const ThankYouWrapper = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  textAlign: "center",
  padding: theme.spacing(2),
}));
const ThankYouMessage = styled(Typography)(({ theme }) => ({
  font: "normal normal 600 24px Poppins",
  whiteSpace: "pre-line",
  textAlign: "left",
  color: "#353535",
  vaiant: "h6",
  component: "p",
}));
const FormComponent = ({ formState, contentState, primaryColor }) => {
  const queryParams = new URLSearchParams(window.location.search);
  const [details, setDetails] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const getLabelName = (meta) => {
    if (meta["required"] === true) {
      return `${meta["label"]}*`;
    } else {
      return meta["label"];
    }
  };

  const handleSubmit = async () => {
    let formData = { payload: { ...details } };
    if (details.hasOwnProperty("phone")) {
      formData["payload"]["phone"] = `+91-${details["phone"]}`;
    }
    if (details.hasOwnProperty("phone")) {
      formData["target"] = `+91-${details["phone"]}`;
    } else if (details.hasOwnProperty("email")) {
      formData["target"] = details["email"];
    } else {
      formData["target"] = "";
    }
    let response = await submitFormApi({
      formID: queryParams.get("form_id"),
      payload: formData,
    });
    setIsSubmitted(true);
  };

  const handleChange = (event) => {
    setDetails({ ...details, [event.target.name]: event.target.value });
  };

  useEffect(() => {
    openFormApi({ formID: queryParams.get("form_id") });
  }, []);

  return (
    <>
      <FormContainer>
        {!isSubmitted ?
          <InputContainer
            component="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleSubmit();
            }}
          >
            <Grid
              container
              rowSpacing={{ xs: 2, md: 0 }}
              sx={(theme) => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                width: "100%",
                py: {
                  xs: theme.spacing(1),
                  md: 0,
                },
              })}
            >
              <Grid
                item
                xs={12}
                md={10}
                lg={9}
                sx={{
                  height: "100%",
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-end" }, // center button on mobile
                  alignItems: "center",
                  padding: { xs: 0, md: "0px 16px" },
                }}
              >
                <Grid container>
                  {formState.map((fieldMeta, index) => {
                    const isLastField = index === formState.length - 1;

                    if (fieldMeta["field_type"] === "dropdown") {
                      return (
                        <Grid
                          item
                          xs={12}
                          md={4}
                          lg={4}
                          key={index}
                          sx={{
                            position: "relative",
                            borderRight: {
                              xs: "none",
                              md: !isLastField ? "2px solid rgba(0,0,0,0.1)" : "none",
                            },
                            padding: { xs: 0, md: "8px 16px" },
                          }}
                        >
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            <SelectComponent
                              name={fieldMeta["field_name"]}
                              fullWidth
                              required={fieldMeta["required"]}
                              input={
                                <OutlinedInputComponent
                                  required={fieldMeta["required"]}
                                />
                              }
                              displayEmpty
                              MenuProps={{
                                disableScrollLock: true,
                              }}
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              onChange={handleChange}
                              disabled={isSubmitted}
                            >
                              {fieldMeta["inputs"].map((item) => {
                                return <MenuItem value={item}>{item}</MenuItem>;
                              })}
                            </SelectComponent>
                          </FieldWrapper>
                        </Grid>
                      );
                    } else if (fieldMeta["field_type"] === "text") {
                      return (
                        <Grid
                          item
                          xs={12}
                          md={4}
                          lg={4}
                          key={index}
                          sx={{
                            position: "relative",
                            borderRight: {
                              xs: "none",
                              md: !isLastField ? "2px solid rgba(0,0,0,0.1)" : "none",
                            },
                            padding: { xs: 0, md: "8px 16px" },
                          }}
                        >
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            <OutlinedInputComponent
                              required={fieldMeta["required"]}
                              placeholder={fieldMeta["label"]}
                              type="text"
                              name={fieldMeta["field_name"]}
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              onChange={handleChange}
                              disabled={isSubmitted}
                            />
                          </FieldWrapper>
                        </Grid>
                      );
                    } else if (fieldMeta["field_type"] === "integer") {
                      return (
                        <Grid
                          item
                          xs={12}
                          md={4}
                          lg={4}
                          key={index}
                          sx={{
                            position: "relative",
                            borderRight: {
                              xs: "none",
                              md: !isLastField ? "2px solid rgba(0,0,0,0.1)" : "none",
                            },
                            padding: { xs: 0, md: "8px 16px" },
                          }}
                        >
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            <OutlinedInputComponent
                              required={fieldMeta["required"]}
                              placeholder={fieldMeta["label"]}
                              type="number"
                              name={fieldMeta["field_name"]}
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              onChange={handleChange}
                              disabled={isSubmitted}
                            />
                          </FieldWrapper>
                        </Grid>
                      );
                    } else if (fieldMeta["field_type"] === "phone") {
                      return (
                        <Grid
                          item
                          xs={12}
                          md={4}
                          lg={4}
                          key={index}
                          sx={{
                            position: "relative",
                            borderRight: {
                              xs: "none",
                              md: !isLastField ? "2px solid rgba(0,0,0,0.1)" : "none",
                            },
                            padding: { xs: 0, md: "8px 16px" },
                          }}
                        >
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            <OutlinedInputComponent
                              required={fieldMeta["required"]}
                              placeholder={fieldMeta["label"]}
                              inputProps={{
                                inputMode: "numeric",
                                pattern: "^[0-9]{10}$",
                                maxLength: 10,
                              }}
                              name={fieldMeta["field_name"]}
                              startAdornment={
                                <InputAdornment position="start">
                                  <CountryCode>+91</CountryCode>
                                </InputAdornment>
                              }
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              onChange={handleChange}
                              disabled={isSubmitted}
                            />
                          </FieldWrapper>
                        </Grid>
                      );
                    } else if (fieldMeta["field_type"] === "email") {
                      return (
                        <Grid
                          item
                          xs={12}
                          md={4}
                          lg={4}
                          key={index}
                          sx={{
                            position: "relative",
                            borderRight: {
                              xs: "none",
                              md: !isLastField ? "2px solid rgba(0,0,0,0.1)" : "none",
                            },
                            padding: { xs: 0, md: "8px 16px" },
                          }}
                        >
                          <FieldWrapper>
                            <Label>{getLabelName(fieldMeta)}</Label>
                            <OutlinedInputComponent
                              required={fieldMeta["required"]}
                              placeholder={fieldMeta["label"]}
                              name={fieldMeta["field_name"]}
                              type="email"
                              value={
                                details.hasOwnProperty(fieldMeta["field_name"])
                                  ? details[fieldMeta["field_name"]]
                                  : ""
                              }
                              onChange={handleChange}
                              disabled={isSubmitted}
                            />
                          </FieldWrapper>
                        </Grid>
                      );
                    }
                  })}
                </Grid>
              </Grid>
              {/* Submit Button */}
              <Grid
                item
                xs={12}
                md={2}
                lg={3}
                sx={{
                  height: "100%",
                  display: "flex",
                  justifyContent: { xs: "center", md: "flex-end" }, // center button on mobile
                  alignItems: "center",
                  padding: { xs: 0, md: "0px 16px" },
                }}
              >
                <Button
                  disabled={isSubmitted}
                  variant="contained"
                  type="submit"
                  sx={{
                    width: { xs: "100%", sm: "100%", md: "120px" },
                    height: { xs: "44px", md: "56px" },
                    px: { xs: 2, md: 3 },
                    backgroundColor: "#1f1d1b",
                    color: "#fff",
                    fontWeight: 400,
                    fontSize: { xs: "14px", sm: "15px", md: "18px" },
                    fontFamily: '"Nunito Sans", "Open Sans", sans-serif',
                    textTransform: "none",
                    borderRadius: "0px",
                    "&:hover": {
                      backgroundColor: "#222",
                      color: "#fff",
                    },
                    "&:active": {
                      backgroundColor: "#1f1d1b",
                      color: "#fff",
                    },
                    "&:focus": {
                      backgroundColor: "#1f1d1b",
                      color: "#fff",
                    },
                  }}
                >
                  Submit
                </Button>
              </Grid>
            </Grid>
          </InputContainer> :
          <ThankYouWrapper>
            <ThankYouMessage>{contentState.thankyou_message}</ThankYouMessage>
          </ThankYouWrapper>}
      </FormContainer>
    </>
  );
};

export default FormComponent;
